import React from "react";
import s from "./MessagingMeta.module.scss";
import { Skeleton } from "antd";
type PropType = {
  totalSuspensions: number;
  totalRevokedNumbers: number;
  totalFailedKyc: number;
  loading: boolean;
};
function ComplianceMeta({
  loading,

  totalFailedKyc,
  totalRevokedNumbers,
  totalSuspensions,
}: PropType) {
  if (loading) {
    return (
      <div className={s.wrapper}>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
        <div className={s.statWrapper}>
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "70%" }}
          />
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 1, width: "80%" }}
          />
        </div>
      </div>
    );
  }
  return (
    <div className={s.wrapper}>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total suspension</h5>
        <p className={s.statNumber}>{totalSuspensions.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total revoked numbers</h5>
        <p className={s.statNumber}>{totalRevokedNumbers.toLocaleString()}</p>
      </div>
      <div className={s.statWrapper}>
        <h5 className={s.statTitle}>Total failed kyc</h5>
        <p className={s.statNumber}>{totalFailedKyc.toLocaleString()}</p>
      </div>
    </div>
  );
}

export default ComplianceMeta;
